
export const processExportResponse = async (response) => {
  if (response?.status !== 200) {
    return null;
  }

  let blobData = response.data;
  let fileName = "gallery_export.pdf";

  const isPdfBlob = blobData instanceof Blob && blobData.type?.includes("application/pdf");
  if (isPdfBlob) {
    return { blob: blobData, fileName };
  }

  const textContent = await extractTextFromBlob(blobData);
  
  if (textContent && typeof textContent === "object") {
    if (textContent.file_name) {
      fileName = textContent.file_name;
    }
  } else if (typeof textContent === "string") {
    try {
      const jsonData = JSON.parse(textContent);
      if (jsonData?.file_name) {
        fileName = jsonData.file_name;
      }
    } catch (parseError) {
      console.debug("Filename extraction from JSON skipped:", parseError.message);
    }
  }

  const base64String = extractBase64(textContent);

  if (!base64String) {
    console.error("Export response is not a recognized PDF format.", response.headers);
    return null;
  }

  return { 
    blob: base64ToBlob(base64String, "application/pdf"), 
    fileName 
  };
};


export const triggerFileDownload = (blob, fileName = "gallery_export.pdf") => {
  if (!blob) return;

  if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
    navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }
};

const extractTextFromBlob = async (data) => {
  if (typeof data === "string") {
    return data;
  }
  if (data instanceof Blob && data.text) {
    return await data.text();
  }
  if (typeof data === "object" && data !== null) {
    return data;
  }
  return "";
};

const extractBase64FromObject = (data) => {
  if (data?.base64) {
    return data.base64;
  }
  if (data?.url) {
    const urlRegex = /^data:application\/pdf;base64,(.+)$/;
    const urlMatch = urlRegex.exec(data.url);
    return urlMatch ? urlMatch[1] : null;
  }
  return null;
};

const extractBase64 = (data) => {
  if (!data) return null;

  // If already an object
  if (typeof data === "object") {
    return extractBase64FromObject(data);
  }

  if (typeof data !== "string") return null;

  const base64Regex = /^(?:data:application\/pdf;base64,)?([A-Za-z0-9+/=\s]+)$/;
  const base64Match = base64Regex.exec(data);
  if (base64Match) {
    return base64Match[1].replaceAll(/\s+/g, "");
  }

  try {
    const json = JSON.parse(data);
    return extractBase64FromObject(json);
  } catch (parseError) {
    // If the data is not JSON, it might be a raw base64/URL string which we handle elsewhere.
    console.debug("Response text is not JSON:", parseError.message);
  }
  return null;
};

const base64ToBlob = (base64, contentType) => {
  const byteCharacters = atob(base64);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 512) {
    const slice = byteCharacters.slice(offset, offset + 512);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.codePointAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
};
